var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJuice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0898 8.36486L17.1552 3.65567L21.8798 1",
    stroke: "#707070",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76172 8.38086H22.9428V16.4714C22.9428 20.9335 19.3144 24.5619 14.8523 24.5619C10.3901 24.5619 6.76172 20.9335 6.76172 16.4714V8.38086Z",
    stroke: "#707070",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2695 31.0006V24.5312",
    stroke: "#707070",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0352 30.4141H20.5034",
    stroke: "#707070",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76172 14.5407C6.76172 14.5407 11.7797 17.8603 14.8523 15.4517C17.9248 13.043 17.9866 12.0703 22.9428 12.0703",
    stroke: "#707070",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46091 4.94925L3.67926 4.73089C5.58986 2.8203 8.69048 2.8203 10.6011 4.73089L3.46091 11.8711C1.55031 9.96047 1.55031 6.85984 3.46091 4.94925Z",
    stroke: "#707070",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56641 4.84478L7.02496 8.30333V3.30078",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02598 8.30273H2.02344",
    stroke: "#707070",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuice);
export default __webpack_public_path__ + "static/media/juice.755f6b9f6de3364f8beadddefce7ec66.svg";
export { ForwardRef as ReactComponent };